/*
 * Author: Dw
 * File Created: Monday, 25-06-16 10:35 am
 * Last Modified: Wednesday, 25-06-18 04:05 pm, by Dw
 */

import { geetestProvider } from './providers/geetest';
import { noneProvider } from './providers/none';

export type ProviderName = 'GEETEST' | 'GRAPHS';

export const PROVIDERS = {
  GEETEST: geetestProvider,
  GRAPHS: noneProvider,
} as const;
